import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 20 21"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("g", { id: "Radio" }, [
  /*#__PURE__*/_createElementVNode("rect", {
    width: "19",
    height: "19",
    x: "0.5",
    y: "1.21094",
    stroke: "currentColor",
    rx: "9.5"
  }),
  /*#__PURE__*/_createElementVNode("circle", {
    id: "Ellipse 47",
    cx: "10",
    cy: "10.7109",
    r: "6.47266",
    fill: "currentColor"
  })
], -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_3]))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "radio-checked"}) } }